import { render, staticRenderFns } from "./aps-viewer.vue?vue&type=template&id=32f21eac&scoped=true"
import script from "./aps-viewer.vue?vue&type=script&lang=js"
export * from "./aps-viewer.vue?vue&type=script&lang=js"
import style0 from "./aps-viewer.vue?vue&type=style&index=0&id=32f21eac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f21eac",
  null
  
)

export default component.exports